import { getField, updateField } from 'vuex-map-fields'
import * as types from '../mutation-types'

const state = {
  isNotification: false,
  notificationTextArr: [],
  notificationType: 'success'
}

const getters = {
  getField
}

const actions = {
  notify ({ commit }, notification) {
    commit(types.NOTIFICATION_CLOSE)

    const arrayOfNotifications = []
    let notificationType

    if (notification.success) {
      notificationType = 'success'
    } else if (notification.errors) {
      notificationType = 'errors'
    } else {
      return commit(types.NOTIFICATION_DISPATCH, {
        textArr: ['Something bad happened. Might be no internet connection'],
        type: 'error'
      })
    }

    const notificationObject = notification[notificationType]

    Object.entries(notificationObject)
      .forEach(([key, arrOfNotificationTexts]) => arrayOfNotifications.push(...arrOfNotificationTexts))

    commit(types.NOTIFICATION_DISPATCH, {
      textArr: arrayOfNotifications,
      type: notificationType === 'errors' ? 'error' : notificationType
    })
  }
}

const mutations = {
  [types.NOTIFICATION_DISPATCH] (state, { textArr, type }) {
    state.isNotification = true
    state.notificationTextArr = textArr
    state.notificationType = type
  },
  [types.NOTIFICATION_CLOSE] (state) {
    state.isNotification = false
    state.notificationTextArr = []
    state.notificationType = ''
  },
  updateField
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
